import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import type { ImageTransform } from 'cloudinary-tiny-js';
import { FallbackImage, IllusEmpty_1, Image } from '@sg/garnish';

import { CustomCategoryImage } from './assets';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellLineItemImage = (props: UpsellLineItemImageProps) => {
  const { imageUrl, lineItemName, isCustom } = props;

  const { formatMessage } = useIntl();

  return (
    <View
      style={styles.image}
      accessibilityLabel={formatMessage(messages.a11yLineItemImage, {
        line_item_name: lineItemName,
      })}
    >
      {isCustom ? (
        <Image
          source={CustomCategoryImage}
          contentFit="contain"
          style={styles.image}
        />
      ) : (
        <FallbackImage
          baseUrl={imageUrl}
          defaultImage={IllusEmpty_1}
          contentFit="contain"
          cloudinaryConfig={CLOUDINARY_CONFIG}
          style={styles.image}
        />
      )}
    </View>
  );
};

// ─────────────────────────────────────────────────────────────────────────────

const IMAGE_SIZE = 250;

const CLOUDINARY_CONFIG: ImageTransform[] = [
  { crop: 'crop', height: 0.6, width: 0.4 },
  { width: IMAGE_SIZE },
];

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  a11yLineItemImage: {
    defaultMessage: 'Image of {line_item_name}',
    description: 'Upsell Modal | Line item image | Accessibility label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  image: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type UpsellLineItemImageProps = {
  imageUrl: string;
  lineItemName: string;
  isCustom?: boolean;
};
